<div class="container">
    <div class="row">
        <hr style="margin:1px" />
        <div style="display: flex; justify-content: space-between; ">
            <div>
            </div>
            <div>
                &#169; EUFIC 2026
            </div>
            <div style="margin-right: 5px;">
                Version {{ build.version }}
            </div>
        </div>
    </div>
</div>